<template>
  <div>
    <b-tabs content-class="mt-3">
      <b-tab title="Insumo">
        <b-form @submit.prevent.stop="salvar">
          <b-form-group
            id="input-group-1"
            label="Código do Insumo"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="insumo.codigo"
              type="text"
              placeholder=""
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-2"
            label="Descrição"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="insumo.descricao"
              placeholder=""
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-2" label="Unidade" label-for="input-3">
            <b-form-select id="input-3" v-model="insumo.unidade" placeholder="">
              <template v-slot:first>
                <b-form-select-option :value="insumo.unidade" disabled>
                  {{ insumo.unidade }}</b-form-select-option
                >
              </template>
              <b-form-select-option
                v-for="unidade in unidades"
                :key="unidade._id"
                :value="unidade.nome"
              >
                {{ unidade.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group
            id="input-group-3"
            label="Estoque Minimo"
            label-for="input-4"
          >
            <b-form-input
              id="input-4"
              v-model="insumo.estoqueBaixo"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-3"
            label="Observação"
            label-for="input-5"
          >
            <b-form-textarea
              id="input-5"
              v-model="insumo.obs"
            ></b-form-textarea>
          </b-form-group>

          <b-button type="submit" variant="primary">Salvar</b-button>
        </b-form>
      </b-tab>
      <b-tab title="Importação">
        <div class="row">
          <div class="col-6">
            <b-button variant="primary" @click="reset">Resetar upload</b-button>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <vue-dropzone
              id="dropzone"
              ref="uploadInsumo"
              :options="dropzoneOptions"
              :use-custom-slot="true"
              @vdropzone-success="vsuccess"
              @vdropzone-sending="vsending"
              @vdropzone-error="verror"
            >
              <div class="text-center">
                <i class="h1 text-muted uil-cloud-upload"></i>
                <h3>Selecione o arquivo para importação de insumos.</h3>
                <span class="text-muted font-size-13">
                  (O arquivo deve ter no máximo 3MB e seguir o padrão
                  EasyControl.)
                </span>
              </div>
            </vue-dropzone>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import listaUnidade from '../../../services/unidadesObras'
import 'vue-multiselect-listbox/dist/vue-multi-select-listbox.css'
import insumoService from '../../../services/serviceInsumoObra'
import alertMixin from '@/src/mixins/alertMixin'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'
export default {
  components: { vueDropzone: vue2Dropzone },
  mixins: [alertMixin],
  props: {
    oi: '',
    oe: {},
    insumo: {
      type: Object,
      require: true,
      default: () => {},
    },
    salvar: {
      type: Function,
      default: () => {},
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      searchInsumo: '',
      unidades: [],
      insumos: [],
      fields: [
        {
          key: 'descricao',
          label: 'Insumos para selecionar',
          sortable: true,
        },
      ],
      fieldsSelected: [
        {
          key: 'descricao',
          label: 'Insumos selecionados',
          sortable: true,
        },
      ],
      dropzoneOptions: {
        url: `${axios.defaults.baseURL}/insumos/uploadinsumo?${this.$store.state.filter}=${this.$store.state.filial}`,
        thumbnailWidth: 150,
        timeout: 100000,
        maxFilesize: 1,
        maxFiles: 1,
        headers: {
          Authorization: this.$store.state.auth.currentUser.access_token,
        },
        acceptedFiles: '.xls,.xlsx',
        addRemoveLinks: true,
        dictRemoveFile: 'Remover arquivo',
      },
      dropzoneItemOptions: {
        url: `${axios.defaults.baseURL}/insumos/uploaditeminsumo`,
        thumbnailWidth: 150,
        timeout: 100000,
        maxFilesize: 1,
        maxFiles: 1,
        headers: {
          Authorization: this.$store.state.auth.currentUser.access_token,
        },
        acceptedFiles: '.xls,.xlsx',
        addRemoveLinks: true,
        dictRemoveFile: 'Remover arquivo',
      },
      currentPage: 0,
      selectMode: 'multi',
      selected: [],
    }
  },
  computed: {
    rows() {
      return this.insumos.length
    },
  },
  mounted() {
    this.onLoadData()
  },

  methods: {
    updateByFiliais() {
      this.$refs.uploadInsumo.setOption(
        'url',
        `${axios.defaults.baseURL}/insumos/uploadinsumo?${this.$store.state.filter}=${this.$store.state.filial}`
      )
    },

    onLoadData() {
      if (this.insumo !== undefined && this.insumo._id !== undefined) {
      }
      this.listaUnidade()
      this.listaInsumo()
      this.setLoading(false)
    },

    justNumber(e) {
      this.numeros = e.target.value.replace(/[^0-9]/g, '')
      this.searchInsumo = this.numeros
    },
    onRowSelected(item) {
      console.log(this.kit.subItens)
      this.kit.subItens.push(item)
    },
    onRowRemove(item) {
      this.kit.subItens.splice(this.kit.subItens.indexOf(item), 1)
    },
    vsuccess(file, response) {
      this.setLoading(false)
      this.successMessage(
        'Arquivo enviado com sucesso, o processo de importação pode levar algum tempo até ser concluído!'
      )
      this.reset()
    },
    vsending(file, xhr, formData) {
      this.setLoading(true)
    },
    verror(file) {
      this.setLoading(false)
      if (!this.$store.state.filial) this.errorMessage('Selecione a Filial')
      else {
        this.errorMessage(
          'Não foi possível importar o arquivo, por favor verifique se o arquivo enviado esta de acordo com o PADRÂO CF Obras.'
        )
      }
    },
    async listaUnidade() {
      let { data } = await listaUnidade.list()
      if (data) {
        this.unidades = data.data
      }
    },
    async listaInsumo() {
      this.setLoading(true)
      insumoService.listByPage(0).then((res) => {
        const { data } = res.data
        this.insumos = data.results
        this.setLoading(false)
      })
    },
    reset() {
      this.$refs.uploadInsumo.removeAllFiles()
    },
  },
}
</script>
